import { TextInput } from '@framework/form';
import { ModalDialog } from '@framework/ui';
import { Button, Space } from 'antd';
import { Map, View } from 'ol';
import Layer from 'ol/layer/Layer';
import TileLayer from 'ol/layer/Tile';
import { OSM } from 'ol/source';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { v4 } from 'uuid';
import { OpenLayersMap } from '../../../../maps/OpenLayerMap';
import { MapLayerType } from '../layers/MapLayer';
import { creteMapLayerFromConfig } from '../layers/rendering/createMapLayerFromConfig';

export interface IMapLayerURLInputProps {
  name: string;
  typeFieldName: string;
}

function useMapURLVerification(
  url: string | null,
  type: MapLayerType | null,
  mapRef: React.MutableRefObject<Map | null>,
) {
  const vectorLayerRef = React.useRef<Layer | null>(null);

  useEffect(() => {
    async function fetchInfo() {
      if (!url || !type) return;
      try {
        if (vectorLayerRef.current)
          mapRef.current?.removeLayer(vectorLayerRef.current);
        const vectorLayer = creteMapLayerFromConfig({
          name: v4(),
          type,
          url,
          style: {
            fillColor: '#ccc',
            opacity: 1,
          },
        });
        vectorLayerRef.current = vectorLayer;
        mapRef.current?.addLayer(vectorLayer);
      } catch (error) {
        console.error('[MapLayerURLInput.error]', error);
      }
    }

    fetchInfo();
  }, [url, type, mapRef]);
}

export function MapLayerURLInput(props: IMapLayerURLInputProps) {
  const { name, typeFieldName } = props;
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const type = useWatch({ name: typeFieldName });
  const url = useWatch({ name });

  const mapRef = React.useRef<Map | null>(null);

  const initMap = React.useCallback((element: HTMLDivElement) => {
    const map = new Map({
      target: element,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center: [1393282.208297, 5145129.247932],
        zoom: 17,
      }),
    });

    mapRef.current = map;
    return map;
  }, []);

  const handlePreview = useCallback(() => {
    setIsPreviewOpen(true);
  }, [setIsPreviewOpen]);

  useMapURLVerification(url, type, mapRef);

  return (
    <Space.Compact block size="large">
      <ModalDialog
        open={isPreviewOpen}
        onCancel={() => setIsPreviewOpen(false)}
        closable
        forceRender
      >
        <OpenLayersMap init={initMap} />
      </ModalDialog>
      <TextInput name={name} placeholder="Inserisci URL" />
      <Button style={{ width: '100px' }} type="primary" onClick={handlePreview}>
        Anteprima
      </Button>
    </Space.Compact>
  );
}
